import { render, staticRenderFns } from "./disease_page.vue?vue&type=template&id=1616ed52&scoped=true"
import script from "./disease_page.vue?vue&type=script&lang=js"
export * from "./disease_page.vue?vue&type=script&lang=js"
import style0 from "./disease_page.vue?vue&type=style&index=0&id=1616ed52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1616ed52",
  null
  
)

export default component.exports